import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { Spinner } from 'reactstrap';
import { profile as fetchProfile } from 'api/v2/admins';

const AuthContext = React.createContext({
  isAuth: false, isLoading: true, user: undefined, onLogin: () => {}, onLogout: () => {},
});

export const AuthProvider = ({ children }) => {
  const history = useHistory();
  const [isAuth, setIsAuth] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = localStorage.getItem('bagspa_token');
        if (!token) return;
        const admin = await fetchProfile();
        if (!cancelled && admin) {
          window.__currentAdmin = admin;
          setUser(admin);
          setIsAuth(true);
        }
      } catch { localStorage.removeItem('bagspa_token'); }
      finally { if (!cancelled) setIsLoading(false); }
    })();
    return () => { cancelled = true; };
  }, []);

  const onLogin = (u) => {
    window.__currentAdmin = u;
    setUser(u);
    setIsAuth(true);
  };
  const onLogout = () => {
    localStorage.removeItem('bagspa_token');
    delete window.__currentAdmin;
    setIsAuth(false); setUser(undefined);
    localStorage.setItem('logout', String(Date.now()));
    history.replace('/');
  };

  useEffect(() => {
    const sync = (e) => { if (e.key === 'logout') history.replace('/'); };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, [history]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ position:'absolute', width:'100%', height:'100%' }}>
        <Spinner color="primary" />
      </div>
    );
  }
  return <AuthContext.Provider value={{ isAuth, isLoading, user, onLogin, onLogout }}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = { children: PropTypes.any };
export const useAuth = () => useContext(AuthContext);
export const useIsAuth = () => useAuth().isAuth;
